import { Button } from "@mui/material";
import { ProjectConfig } from "Global";
import { ApiRequest } from "GlobalFunctions";
import { useEffect, useState, useCallback } from "react";
import { useSnackbar, withSnackbar } from 'notistack';
import { LoadingButton } from "@mui/lab";
import { useLocation } from "react-router-dom";
import SignupForm from "./SignupForm";

export default function Signup(props:any) {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [sites, setSites] = useState([]);
    const location = useLocation();

    const {setLoading} = props;

    // Check if we should show the registration form
    const shouldShowRegistrationForm = () => {
        const searchParams = new URLSearchParams(location.search);
        const pathname = location.pathname;
        
        // Check if URL contains /accept-transfer and has tid parameter
        return pathname.includes('/accept-transfer') && searchParams.has('tid');
    };


    const getUrlParams = () => {
        const searchParams = new URLSearchParams(window.location.search);
        const params: Record<string, string> = {};
        
        searchParams.forEach((value, key) => {
            params[key] = value;
        });
        
        return params;
    };


    const handleAuthData = useCallback(() => {
        const params = getUrlParams();
        
        console.log("Checking URL parameters:", params);
        
        if (params.status === 'success' && params.ltkn) {
            setLoading(true);
            localStorage.setItem('ltkn', params.ltkn);
            localStorage.setItem('role_id', "1");
            localStorage.setItem('store_id', params.store_id || '');

            enqueueSnackbar(params.message || 'Authentication successful', {
                variant: 'success',
                autoHideDuration: 3000
            });
            
            if (params.shortName) {
                const webflowUrl = `https://${params.shortName}.design.webflow.com/?app=${ProjectConfig.WEBFLOW_CLIENT_ID}&mode=.`;
                window.location.href = `/account/?openWebflow=true&webflowUrl=${encodeURIComponent(webflowUrl)}`;
            } else {

                if (params.same_site === 'true') {
                    // Redirect to account without webflow params
                    window.location.href = '/account/';
                } else if (params.different_site === 'true') {
                    window.location.href = '/account/?show_different_site=true';
                } else {
                    window.location.reload();
                }

                
            }
            
            window.history.replaceState(null, '', window.location.pathname);
            
            return true;
        } else if (params.status === 'error') {
            enqueueSnackbar(params.message || 'Authentication failed', { 
                variant: 'error',
                autoHideDuration: 5000
            });
            
            window.history.replaceState(null, '', window.location.pathname);
            
            return true;
        }
        
        return false;
    }, [enqueueSnackbar]);

    useEffect(() => {
        // Only handle auth data if we're not showing the registration form
        if (!shouldShowRegistrationForm()) {
            handleAuthData();
        }
    }, [handleAuthData]);

    // If we should show the registration form, render it instead
    if (shouldShowRegistrationForm()) {
        return <SignupForm setLoading={setLoading} />;
    }

    const openWebflowAuth = () => {
        
        // Build the auth URL
        let url = `https://webflow.com/oauth/authorize?response_type=code`
        url += `&client_id=${ProjectConfig.WEBFLOW_CLIENT_ID}`
        url += `&redirect_uri=`
        url += `&state=signup`
        url += `&scope=assets%3Aread%20assets%3Awrite%20authorized_user%3Aread%20cms%3Aread%20cms%3Awrite%20custom_code%3Aread%20custom_code%3Awrite%20forms%3Aread%20forms%3Awrite%20pages%3Aread%20pages%3Awrite%20sites%3Aread%20sites%3Awrite%20ecommerce%3Aread%20ecommerce%3Awrite%20users%3Aread%20users%3Awrite`;
        
        window.location.href = url;
    };

    return (
        <div className="signup_container">
            <h2>Quick Connect</h2>
            <p>Create Your Penni Cart Account</p>
                <Button 
                    variant="contained" 
                    color="primary"
                    onClick={openWebflowAuth}
                >
                    Create Account
                </Button>
        </div>
    )
}